/* Native scroll reveals: content remains readable without JavaScript. */
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll('.pdp-story [data-reveal]');
  const animations = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (preference.matches) return;
      const animation = entry.target.animate([
        {opacity:0, transform:'translateY(32px)'},
        {opacity:1, transform:'translateY(0)'}
      ], {duration:850, easing:'cubic-bezier(.2,.7,.2,1)', delay:entry.target.matches('li') ? [...entry.target.parentNode.children].indexOf(entry.target)*90 : 0});
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
    });
  }, {threshold:0.08, rootMargin:'0px 0px -24px 0px'});
  targets.forEach(target => observer.observe(target));
  preference.addEventListener('change', () => { if (preference.matches) animations.forEach(animation => animation.cancel()); });
})();
